"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const Alert_1 = __importDefault(require("../../components/Alert"));
const ArrowButton_1 = __importDefault(require("../../components/ArrowButton"));
const Button_1 = __importDefault(require("../../components/Button"));
const IconType_1 = __importDefault(require("../../components/enums/IconType"));
const GoogleButton_1 = __importDefault(require("../../components/GoogleButton"));
const IdHeader_1 = __importDefault(require("../../components/IdHeader"));
const IllustrationWithDrawing_1 = __importDefault(require("../../components/illustrations/IllustrationWithDrawing"));
const ResetPasswordDone_1 = __importDefault(require("../../components/popups/ResetPasswordDone"));
const TextInput_1 = __importDefault(require("../../components/TextInput"));
const Login = () => {
    //Screen State Variables
    const [isWelcome, setIsWelcome] = (0, react_1.useState)(true);
    const [driverUserError, setDriverUserError] = (0, react_1.useState)(false);
    const [isCreateNewPassword, setIsCreateNewPassword] = (0, react_1.useState)(false);
    const [isNewPasswordDone, setIsNewPasswordDone] = (0, react_1.useState)(false);
    const [isLoginError, setIsLoginError] = (0, react_1.useState)(false);
    const [isLoginFormFilled, setIsLoginFormFilled] = (0, react_1.useState)(false);
    const [isResetPasswordFormFilled, setIsResetPasswordFormFilled] = (0, react_1.useState)(false);
    const [emailErrorState, setEmailErrorState] = (0, react_1.useState)("");
    const [passwordErrorState, setPasswordErrorState] = (0, react_1.useState)("");
    //Error messages
    const serverErrorMessage = "An unexpected server error occurred during login!";
    const authErrorMessage = "Wrong email and/or password!";
    //Login Form Variables
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (isWelcome && email.length !== 0) {
            setIsLoginFormFilled(true);
        }
        else if (email.length !== 0 && password.length !== 0) {
            setIsLoginFormFilled(true);
        }
        else {
            setIsLoginFormFilled(false);
        }
    }, [email, password]);
    const handleLogin = (e) => {
        e.preventDefault();
        setEmailErrorState("");
        setPasswordErrorState("");
        setIsLoginError(false);
        fetch("/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    if (content.response.message == "wrong_user_data") {
                        for (let i = 0; i < content.response.data.length; i++) {
                            let w = content.response.data[i];
                            if (w == "email") {
                                setEmailErrorState("The specified email address cannot be found!");
                            }
                            if (w == "password") {
                                setPasswordErrorState("The entered password is incorrect!");
                            }
                        }
                    }
                    return;
                }
                if (window.ReactNativeWebView &&
                    content.response.token) {
                    window.ReactNativeWebView.postMessage(content.response.token);
                    return;
                }
                else {
                    if (content.response.action) {
                        window.location.href = content.response.action;
                        return;
                    }
                }
            })
                .catch(() => { });
        })
            .catch(() => { });
    };
    const handleEmailCheck = (e) => {
        e.preventDefault();
        fetch("/login/check", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: email,
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (content.success) {
                    setIsWelcome(false);
                    setIsLoginFormFilled(false);
                }
                else {
                    if (content.response.action) {
                        if (!!window.ReactNativeWebView) {
                            setDriverUserError(true);
                        }
                        else {
                            window.location.href =
                                content.response.action;
                        }
                    }
                }
            })
                .catch(() => { });
        })
            .catch(() => { });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IdHeader_1.default, { hideBackButton: true, handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "login" },
            react_1.default.createElement("section", { className: "login__content" }, isWelcome === false ? (react_1.default.createElement("div", { className: "login__form-container" },
                react_1.default.createElement("h1", { className: "login__title" }, "Let's sign-in!"),
                react_1.default.createElement("form", { className: "login__form", onSubmit: handleLogin },
                    react_1.default.createElement("div", { className: "login__inputs" },
                        react_1.default.createElement(TextInput_1.default, { label: "Email", name: "email", value: email, onChangeHandler: setEmail, placeholder: "example@mail.com", isRequired: true, type: "email", state: emailErrorState != ""
                                ? "error"
                                : "normal", errorText: emailErrorState, unit: "" }),
                        react_1.default.createElement(TextInput_1.default, { label: "Password", name: "password", value: password, onChangeHandler: setPassword, placeholder: "Enter your password", isRequired: true, type: "password", state: passwordErrorState != ""
                                ? "error"
                                : "normal", errorText: passwordErrorState, unit: "" })),
                    react_1.default.createElement("div", { className: "login__forgot-password" },
                        react_1.default.createElement(Button_1.default, { label: "Forgotten password", type: "tertiary", state: "enabled", icon: IconType_1.default.None, handlerFunction: function () {
                                window.location.href =
                                    "/forgot-password";
                            } })),
                    react_1.default.createElement(Button_1.default, { label: "Log in", type: "primary", state: isLoginFormFilled
                            ? "enabled"
                            : "disabled", icon: IconType_1.default.None, handlerFunction: () => { }, action: "submit" })))) : (react_1.default.createElement("div", { className: "login__form-container" },
                react_1.default.createElement("h1", { className: "login__title" }, "Let's sign-in!"),
                react_1.default.createElement("form", { className: "login__welcome-form", onSubmit: handleEmailCheck },
                    react_1.default.createElement(TextInput_1.default, { label: "Email", name: "email", value: email, onChangeHandler: setEmail, placeholder: "example@mail.com", isRequired: true, type: "email", unit: "", state: driverUserError
                            ? "error"
                            : "normal", errorText: "User not found" }),
                    react_1.default.createElement(Button_1.default, { label: "Continue", type: "primary", state: isLoginFormFilled
                            ? "enabled"
                            : "disabled", icon: IconType_1.default.None, handlerFunction: () => { }, action: "submit" }),
                    react_1.default.createElement(GoogleButton_1.default, { label: "Continue with Google account", handlerFunction: () => {
                            window.location.href = "/login/google";
                        } }),
                    !window.ReactNativeWebView && (react_1.default.createElement("div", { className: "login__register-button" },
                        react_1.default.createElement(ArrowButton_1.default, { direction: "right", label: "Registration", handlerFunction: function () {
                                window.location.href =
                                    "/register";
                            } }))))))),
            react_1.default.createElement("div", { className: "login__illustration" },
                react_1.default.createElement("h1", { className: "profile__title-mobile" }, isWelcome ? "Welcome" : "Log in"),
                react_1.default.createElement(IllustrationWithDrawing_1.default, { isWelcome: isWelcome }))),
        react_1.default.createElement(react_1.default.Fragment, null,
            isNewPasswordDone === true ? (react_1.default.createElement(ResetPasswordDone_1.default, { closeFunction: () => setIsNewPasswordDone(false) })) : (react_1.default.createElement(react_1.default.Fragment, null)),
            isLoginError === true ? (react_1.default.createElement(Alert_1.default, { type: "error", label: authErrorMessage, closeFunction: () => setIsLoginError(false) })) : (react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = Login;
if (document.getElementById("guest-login")) {
    (0, client_1.createRoot)(document.getElementById("guest-login")).render(react_1.default.createElement(Login, null));
}
